import { AsYouType } from "libphonenumber-js";

export const getPhoneNumber = (value) => {
  if (value === "1" || value === "0" || !value) return "";

  if (value.includes("(") && !value.includes(")")) {
    const tempValue = value.replace("(", "");
    return tempValue.slice(0, tempValue.length - 1);
  }

  return new AsYouType("US").input(value);
};

export const extractDigits = (string) => string.match(/\d/g).join("");

export const getFullName = (firstName = "", lastName = "") =>
  `${firstName}${lastName ? ` ${lastName}` : ""}`;

export const getNameAbbreviation = (firstName, lastName) =>
  `${firstName}${lastName ? ` ${lastName.charAt(0)}` : ""}`;

export const lettersOnly = (string) =>
  /^[a-zA-Z-'. ]+$/.test(string) || string.length === 0;

export const alphaNumeric = (string) =>
  /^[a-zA-Z0-9,.\s]*$/.test(string) || string.length === 0;

export const digitsOnly = (string) =>
  /^\d+$/.test(string) || string.length === 0;

export const isValidLat = (string) =>
  (Number.isFinite(+string) && Math.abs(string) <= 90) || string === "-";

export const isValidLong = (string) =>
  (Number.isFinite(+string) && Math.abs(string) <= 180) || string === "-";

export const capitalize = (name = "") =>
  name.charAt(0).toUpperCase() + name.slice(1);

export const uncapitalize = (name = "") =>
  name.charAt(0).toLowerCase() + name.slice(1);

export const toUpperCase = (string) => string?.toUpperCase();

export const isValidEmail = (email) => {
  const regex = /^[\w.-]+@[\w.-]+\.[\w.]+$/;
  return email && !!email.match(regex);
};

export const toKebabCase = (string = "") =>
  typeof string === "string" && string.replace(/\s+/g, "-").toLowerCase();

export const separateWords = (string = "") =>
  string.split(/(?=[A-Z])/).join(" ");

export const getAbbreviation = (name) =>
  name
    .split(" ")
    .map(([firstLetter]) => firstLetter)
    .join("")
    .toUpperCase();

export const handleInputRestrictions = (e) => {
  const invalidKeys = [".", "e", "+", "-"];

  if (e.type === "keydown" && invalidKeys.includes(e.key)) {
    e.preventDefault();
  }

  if (e.type === "input" && e.target.value === "0") {
    e.target.value = "";
  }
};

export const maxInputLength = (string, maxLength) => {
  if (string.length > maxLength) {
    return string.slice(0, maxLength);
  }
  return string;
};

export const removeSpaces = (str) => str.replace(/\s+/g, "");

export const addSpaces = (str) => str?.replace(/([a-z])([A-Z])/g, "$1 $2");
